import React, { useEffect, useState, useRef } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import MobileTaskbar from './MobileTaskbar';
import MobileCard from './MobileCard';
import MobileProjectDetail from './MobileProjectDetail';
import MobileOnboarding from './MobileOnboarding';
import { PortfolioItem } from '../../data/portfolioData';
import { useNavigate } from 'react-router-dom';
interface MobilePortfolioProps {
  items: PortfolioItem[];
}
const MobilePortfolio: React.FC<MobilePortfolioProps> = ({
  items
}) => {
  const navigate = useNavigate();
  const [currentCategory, setCurrentCategory] = useState<string>('all');
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedProject, setSelectedProject] = useState<PortfolioItem | null>(null);
  const [showOnboarding, setShowOnboarding] = useState(() => {
    const hasVisited = localStorage.getItem('hasVisitedPortfolio');
    return !hasVisited;
  });
  const [backgroundColor, setBackgroundColor] = useState('bg-gray-50');
  const [showImpressum, setShowImpressum] = useState(false);
  const [isFilterAnimating, setIsFilterAnimating] = useState(false);
  const [showInstructions, setShowInstructions] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const containerRef = useRef<HTMLDivElement>(null);
  const filteredItems = items.filter(item => {
    if (currentCategory === 'all') return true;
    if (Array.isArray(item.category)) {
      return item.category.includes(currentCategory);
    }
    return item.category === currentCategory;
  });
  useEffect(() => {
    if (showOnboarding) {
      const timer = setTimeout(() => {
        setShowOnboarding(false);
        localStorage.setItem('hasVisitedPortfolio', 'true');
      }, 3000);
      return () => clearTimeout(timer);
    }
  }, [showOnboarding]);
  useEffect(() => {
    if (filteredItems[currentIndex]) {
      const category = Array.isArray(filteredItems[currentIndex].category) ? filteredItems[currentIndex].category[0] : filteredItems[currentIndex].category;
      switch (category) {
        case 'Photo':
          setBackgroundColor('bg-gradient-to-br from-rose-50 to-pink-50/70');
          break;
        case 'Video':
          setBackgroundColor('bg-gradient-to-br from-indigo-50 to-blue-50/70');
          break;
        case 'Motion Design':
          setBackgroundColor('bg-gradient-to-br from-violet-50 to-purple-50/70');
          break;
        default:
          setBackgroundColor('bg-gradient-to-br from-gray-50 to-slate-50/70');
      }
    }
  }, [currentIndex, filteredItems]);
  useEffect(() => {
    const handleScroll = () => {
      if (!containerRef.current) return;
      const {
        scrollTop,
        scrollHeight,
        clientHeight
      } = containerRef.current;
      const isNearBottom = scrollHeight - (scrollTop + clientHeight) < 100;
      setShowFooter(isNearBottom);
    };
    const container = containerRef.current;
    if (container) {
      container.addEventListener('scroll', handleScroll, {
        passive: true
      });
      return () => container.removeEventListener('scroll', handleScroll);
    }
  }, []);
  const handleProjectOpen = (project: PortfolioItem) => {
    const slug = project.title.toLowerCase().replace(/\s+/g, '-');
    navigate(`/project/${slug}`, {
      state: {
        project
      }
    });
  };
  const handleSwipe = (swipeDirection: 'left' | 'right', project: PortfolioItem) => {
    if (swipeDirection === 'right') {
      handleProjectOpen(project);
    } else {
      if (currentIndex < filteredItems.length - 1) {
        setCurrentIndex(prev => prev + 1);
      } else {
        setCurrentIndex(0);
      }
    }
  };
  const handleCategoryChange = (category: string) => {
    if (category === currentCategory) return;
    setIsFilterAnimating(true);
    setTimeout(() => {
      setCurrentCategory(category);
      setCurrentIndex(0);
      setIsFilterAnimating(false);
    }, 300);
  };
  const handleReturnToCards = () => {
    setSelectedProject(null);
  };
  return <div className={`fixed inset-0 ${backgroundColor} transition-colors duration-700`} data-id="element-168">
      <div className="fixed top-0 left-0 right-0 z-40 bg-white/90 backdrop-blur-lg shadow-sm" data-id="element-169">
        <div className="px-4 py-3" data-id="element-170">
          <Link to="/" onClick={() => setSelectedProject(null)} data-id="element-171">
            <h1 className="text-xl font-bold text-center" data-id="element-172">nickszusehen</h1>
          </Link>
        </div>
        <MobileTaskbar currentCategory={currentCategory} onCategoryChange={handleCategoryChange} data-id="element-173" />
      </div>
      <div ref={containerRef} className="relative h-full pt-24 overflow-auto scroll-smooth" data-id="element-174">
        <div className="min-h-[100vh] flex flex-col" data-id="element-175">
          <div className="flex-1 flex items-end justify-center px-4 pb-32 pt-12" data-id="element-176">
            <AnimatePresence mode="wait" data-id="element-177">
              {!selectedProject && <motion.div key="card-stack" className="relative w-full max-w-xs mx-auto h-[65vh]" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} exit={{
              opacity: 0
            }} data-id="element-178">
                  {filteredItems.slice(currentIndex, currentIndex + 5).map((project, idx) => <MobileCard key={`${project.id}-${idx}`} project={project} onSwipe={handleSwipe} isActive={idx === 0} stackIndex={idx} totalCards={filteredItems.length} isPlaceholder={project.isPlaceholder} data-id="element-179" />)}
                </motion.div>}
            </AnimatePresence>
          </div>
          <motion.div className="sticky bottom-0 left-0 right-0 pb-4 pt-8" initial={{
          opacity: 0
        }} animate={{
          opacity: showFooter ? 1 : 0
        }} transition={{
          duration: 0.3
        }} data-id="element-180">
            <div className="bg-gradient-to-t from-white/90 to-transparent backdrop-blur-sm" data-id="element-181">
              <div className="px-6 py-4 space-y-6" data-id="element-182">
                <div className="space-y-3 text-sm text-gray-600" data-id="element-183">
                  <p className="flex items-center justify-center gap-2" data-id="element-184">
                    <motion.span animate={{
                    x: [-5, 5, -5]
                  }} transition={{
                    repeat: Infinity,
                    duration: 2
                  }} data-id="element-185">
                      ←
                    </motion.span>
                    Nach links wischen: nächstes Projekt
                  </p>
                  <p className="flex items-center justify-center gap-2" data-id="element-186">
                    Nach rechts wischen: Projekt öffnen
                    <motion.span animate={{
                    x: [0, 5, 0]
                  }} transition={{
                    repeat: Infinity,
                    duration: 2
                  }} data-id="element-187">
                      →
                    </motion.span>
                  </p>
                </div>
                <Link to="/impressum" className="block w-full py-2 text-center text-gray-600 font-medium hover:text-gray-800" data-id="element-188">
                  Impressum
                </Link>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
      <MobileOnboarding isVisible={showOnboarding} onDismiss={() => setShowOnboarding(false)} data-id="element-189" />
    </div>;
};
export default MobilePortfolio;